export enum BtnTypes {
  primary = "btn-primary",
  secondary = "btn-secondary",
}
